import { getRequest, postRequest, deleteRequest } from './base';

export const changeUserPassword = (id, password) => {
  return postRequest('user/setPassword', {
    id,
    password,
  }).then((response) => response.data);
};

export const getUserFiltersView = async (section) => {
  const response = await getRequest(`/filters/list?section=${section}`);

  return response.data;
};

export const createUserFiltersView = async (section, filters, name) => {
  const filterWithValues = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value)
  );
  const response = await postRequest(`/filters`, {
    section,
    filters: filterWithValues,
    name,
  });

  return response.data;
};

export const deleteUserFiltersView = async (id) =>
  (await deleteRequest(`/filters/delete/${id}`)).data;

export const getAuthenticatedUsers = async (
  authenticatedUsersAbortController
) => {
  const response = await getRequest('/authenticatedUsers', {
    signal: authenticatedUsersAbortController.signal,
  });
  return response.data;
};
